export default __webpack_public_path__ + "static/media/child.3f98aaba.png";